import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../navbar/model/logo';
import CallOutlined from '@mui/icons-material/CallOutlined';
import Mail from '@mui/icons-material/MailOutline';
import Pin from '@mui/icons-material/LocationPin';
import { FooterNavSocialMedia } from './footernav_socialmedia';
import { FooterNavInfo } from './footernav_info';
import { FooterNavItem } from './footernav_item';

type FooterNavProps = {
  logo: Logo;
  navItems: Array<FooterNavItem>;
  socialMedia: Array<FooterNavSocialMedia>;
  info: Array<FooterNavInfo>
}

export default function FooterNav({ logo, navItems, socialMedia, info }: FooterNavProps) {
  return (
    <footer className="bg-[#E9E7F5] py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Logo APAMI centralizado */}
        <div className="text-center mb-6">
          <div className="flex justify-center items-center mb-2">
            <Link to="/" className="flex justify-center items-center">
              <img src={logo.src} alt={logo.alt} className="h-20 w-auto" />
            </Link>
          </div>
        </div>

        {/* Layout em três colunas */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          
          {/* Coluna 1: Links de Navegação */}
          <div>
            <h3 className="font-semibold text-[#3A3168] mb-4">APAMI</h3>
            <ul className="space-y-2">
              {navItems.map((item, idx) => (
                <li key={`${item.text}-${idx}`}>
                  {item.to ? (
                    <Link to={item.to} className="text-slate-600 hover:text-[#3A3168] transition-colors">
                      {item.text}
                    </Link>
                  ) : (
                    <a href={item.href} className="text-slate-600 hover:text-[#3A3168] transition-colors">
                      {item.text}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 2: Redes Sociais */}
          <div className="flex justify-center self-start md:justify-center">
            <div className="flex items-center gap-4">
              {socialMedia.map((item, idx) => (
                <a key={`${item.text}-${idx}`} href={item.href} target="_blank" rel="noopener noreferrer" className={`w-8 h-8 flex rounded-full items-center justify-center hover:bg-[#EAEAEA] transition-colors`}>
                  {item.icon && React.createElement(item.icon, { sx: { fontSize: 24 }, className: 'text-[#3A3168]' })}
                </a>
              ))}
            </div>
          </div>

          {/* Coluna 3: Informações de Contato */}
          <div>
            <div className="flex items-center flex-col space-y-2 text-slate-600">
              {info.map((item, idx) => (
                <div key={`${item.text}-${idx}`} className="flex items-start justify-center w-[60%] md:w-full md:justify-start gap-2">
                  {React.createElement(item.icon, { sx: { fontSize: 16 }, className: 'text-slate-600 mt-0.5' })}
                  <span className="text-sm">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
